import React from "react";

import "./style.scss";

export const VisuallyHiddenClassName = "visually-hidden";

export const VisuallyHidden = props => <span className={VisuallyHiddenClassName} {...props} />;

export default VisuallyHidden;
